import { setElementStyleAttribute, sleep } from "../lib/utils.js"

const BANNER_FIXED_MQ = "(min-width: 48em)"

class FFNav{

	headerRetracted = false
	openPanel?: HTMLElement
	bannerResizeObserver?: ResizeObserver

  DOM: {
    header: HTMLElement | null
    banner: HTMLElement | null
    nav: HTMLElement | null
    links: NodeListOf<HTMLElement>
    panels: NodeListOf<HTMLElement>
    tier3Menu: HTMLElement | null
    tier3Trigger: HTMLElement | null
    tier3MenuContent: HTMLElement | null
    tier3MenuInner: HTMLElement | null
  }

	constructor(){
		this.DOM = {
			header: document.querySelector('#ff-header-site'),
			banner: document.querySelector('#ff-banner-top'),
			nav: document.querySelector('#ff-nav-site'),
			links: document.querySelectorAll('#ff-nav-site .anchor-level-1'),
			panels: document.querySelectorAll('.ff-panel-tier-2'),
			tier3Menu: document.querySelector('.tier3Menu'),
			tier3Trigger: document.querySelector('.tier3MobileMenuTrigger'),
			tier3MenuContent: document.querySelector('.tier3Menu .tier3MobileMenuContent'),
			tier3MenuInner: document.querySelector('.tier3Menu .tier3MobileMenuContent .inner'),
		}
		this.events();
		this.updateBannerHeight();
	}

	events(){
    this.DOM.links.forEach(el => {
      el.addEventListener( 'click', this.togglePanel.bind(this) );
    })

		if( this.DOM.tier3Menu ){
			document.addEventListener( 'optimizedScroll', this.scrollUpdate.bind(this) );
		}

		window.addEventListener( 'optimizedResize', this.updateBannerHeight.bind(this) );

		if( this.DOM.banner && typeof ResizeObserver !== "undefined" ){
			this.bannerResizeObserver = new ResizeObserver(() => {
				this.updateBannerHeight();
			});
			this.bannerResizeObserver.observe(this.DOM.banner);
		}
		
		this.DOM.tier3Trigger?.addEventListener('click', this.toggleTier3.bind(this));
	}

	updateBannerHeight(){
		const header = this.DOM.header;
		const banner = this.DOM.banner;
		if( !header ) return;

		if( !banner || window.matchMedia(BANNER_FIXED_MQ).matches ){
			header.style.removeProperty('--ff-banner-height');
			return;
		}

		header.style.setProperty('--ff-banner-height', `${banner.offsetHeight}px`);
	}

	async togglePanel(e: MouseEvent){
		const el = e.currentTarget;
    if( !(el instanceof HTMLElement )) return
		const collection = el.getAttribute('data-collection');
		const target = document.querySelector( `#ff-tier-2-${collection}` );
		
    if( !(target instanceof HTMLElement )) return
		e.preventDefault();
		
		if( el.classList.contains('ff-active') ){
			el.classList.remove('ff-active');
			target.style.removeProperty("transform")
			await sleep(300)
			target.style.removeProperty("display")
			this.DOM.nav?.classList.remove('ff-nav-expanded');
			this.openPanel = undefined
		}else{
			//close any open panels
			await this.closeAll();
			el.classList.add('ff-active');
			target.style.display = "block";
			await sleep(10)
			target.style.transform = "translateZ(0)";
			this.DOM.nav?.classList.add('ff-nav-expanded');
			this.openPanel = target
		}
	}

	async closeAll(){
    this.DOM.links.forEach(el => {
      el.classList.remove('ff-active');
    })
		const panel = this.openPanel
		if( panel ){
			panel.style.removeProperty("transform")
			await sleep(300)
			panel.style.removeProperty("display")
			if( this.openPanel === panel ){
				this.openPanel = undefined
			}
		}
	}

	scrollUpdate(){
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		
		if( scrollTop > 200 && !this.headerRetracted ){
			this.DOM.header?.classList.add('retract');
			this.headerRetracted = true;
		}else if( scrollTop < 200 && this.headerRetracted ){
			this.DOM.header?.classList.remove('retract');
			this.headerRetracted = false;
		}
	}

  closeTier3() {
    this.DOM.tier3Trigger?.classList.remove('active');
    this.DOM.tier3MenuContent?.classList.remove('active');
    setElementStyleAttribute(this.DOM.tier3MenuContent, "height", "0");
  }

  openTier3() {
    const h = this.DOM.tier3MenuInner?.clientHeight;
    this.DOM.tier3Trigger?.classList.add('active');
    this.DOM.tier3MenuContent?.classList.add('active');
    setElementStyleAttribute(this.DOM.tier3MenuContent, "height", `${h}px`);
  }

  toggleTier3(e: MouseEvent) {
    e.preventDefault();
    if (this.DOM.tier3Trigger?.classList.contains('active')) {
      this.closeTier3();
    } else {
      this.openTier3();
    }
  }
};
new FFNav()
